import classNames from 'classnames';
import { useMemo } from 'react';

export function BatteryIcon({
  value,
  disabled = false,
  charging,
}: {
  value: number;
  disabled?: boolean;
  charging: boolean;
}) {
  const col = useMemo(() => {
    if (disabled) return 'fill-background-40';
    else if (charging) return 'fill-status-success';

    const colorsMap: { [key: number]: string } = {
      0.4: 'fill-status-success',
      0.2: 'fill-status-warning',
      0: 'fill-status-critical',
    };

    const val = Object.keys(colorsMap)
      .filter((key) => +key < value)
      .sort((a, b) => +b - +a)[0];
    return colorsMap[+val] || 'fill-background-10';
  }, [value, disabled, charging]);

  return (
    <svg
      width="19"
      height="11"
      viewBox="0 0 19 9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0833 0H1.31203C0.995003 0.00131561 0.691347 0.121213 0.467167 0.333594C0.242986 0.545976 0.116428 0.83365 0.115039 1.134V7.383C0.114754 7.68458 0.240506 7.97399 0.464808 8.18799C0.689109 8.40198 0.993714 8.52315 1.31203 8.525H11.0833V0Z"
        fill="#3D6381"
      />
      <path
        d="M15.0005 8.525C15.3175 8.52368 15.6212 8.40379 15.8454 8.19141C16.0696 7.97902 16.1961 7.69135 16.1975 7.391V5.968H17.9972V2.558H16.1975V1.134C16.1961 0.83365 16.0696 0.545976 15.8454 0.333594C15.6212 0.121213 15.3175 0.00131561 15.0005 0H10.9672V8.525H15.0005Z"
        fill="#3D6381"
      />
      <mask
        id="mask0_4_39"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="9"
      >
        <path
          d="M11.0833 0H1.31203C0.995003 0.00131561 0.691347 0.121213 0.467167 0.333594C0.242986 0.545976 0.116428 0.83365 0.115039 1.134V7.383C0.114754 7.68458 0.240506 7.97399 0.464808 8.18799C0.689109 8.40198 0.993714 8.52315 1.31203 8.525H11.0833V0Z"
          fill="#3D6381"
        />
        <path
          d="M15.0005 8.525C15.3175 8.52368 15.6212 8.40379 15.8454 8.19141C16.0696 7.97902 16.1961 7.69135 16.1975 7.391V5.968H17.9972V2.558H16.1975V1.134C16.1961 0.83365 16.0696 0.545976 15.8454 0.333594C15.6212 0.121213 15.3175 0.00131561 15.0005 0H10.9672V8.525H15.0005Z"
          fill="#3D6381"
        />
      </mask>
      <g mask="url(#mask0_4_39)" className={classNames(col, 'opacity-100')}>
        <rect width={charging ? 18 : value > 2 ? 0 : value * 18} height="9" />
      </g>
      {charging && (value <= 1 || value > 2) && (
        <path
          d="M 7.7638355,8.4189633 8.0112251,4.9834646 5.7712838,4.9834645 8.5644084,0.07977871 8.3170195,3.5152773 H 10.55696 Z"
          fill="#081e30"
        />
      )}
      {charging && value > 1 && value <= 2 && (
        <path
          d="M 5.5342464,4.6225095 C 6.1777799,5.0106205 6.6131537,5.2516456 7.5253371,6.545223 8.4340868,4.4016445 8.7809738,3.661475 10.605195,1.5520288"
          fill="none"
          stroke="#081e30"
          strokeWidth={1.5}
          strokeLinecap="square"
        />
      )}
    </svg>
  );
}
